export const reportsDetailsModel = ({
                                        reportType,
                                        districtId,
                                        startDate,
                                        endDate,
                                    }: Record<string, any> = {}) => ({
    reportType: reportType ?? ``,
    districtId: districtId ?? ``,
    startDate,
    endDate,
});